// Session-only stale-while-revalidate cache of group metadata (writer,
// schedule, rotation, members) — the /groups/{id} response. Same pattern and
// privacy posture as groups.ts's historyCache: a plain in-memory Map, never
// persisted, gone on reload. Metadata only — no letter content lives here.

import { apiFetch } from "./api.js";
import type { GroupDetail } from "./api-types.js";

const cache = new Map<string, GroupDetail>();

export function cachedGroupDetail(groupId: string): GroupDetail | undefined {
  return cache.get(groupId);
}

/** Fetch fresh metadata and update the cache. */
export async function fetchGroupDetail(groupId: string): Promise<GroupDetail> {
  const data: GroupDetail = await apiFetch(`/groups/${groupId}`);
  cache.set(groupId, data);
  return data;
}
